::ng-deep particle-task-body-default-view{display:flex;flex-grow:1;height:0}::ng-deep particle-task-body-default-view .task-title{word-wrap:break-word}
/*# sourceMappingURL=task-body-default-view.component-XMELGXSG.css.map */
